export const hasRole = (roles, targetRoles) => {
  return roles.some((role) => targetRoles.includes(role));
};
